import {Button, Icon, clx} from '@hm/fundamental'
import {mdiMinus, mdiPlus, mdiRefresh} from '@mdi/js'

type DrawingZoomProps = {
  zoomPercentage: number
  onZoomIn: () => void
  onZoomOut: () => void
  onReset: () => void
  canZoomIn: boolean
  canZoomOut: boolean
  isAtDefaultZoom: boolean
}

export const DrawingZoom = ({
  zoomPercentage,
  onZoomIn,
  onZoomOut,
  onReset,
  canZoomIn,
  canZoomOut,
  isAtDefaultZoom
}: DrawingZoomProps) => {
  return (
    <div className="absolute bottom-4 right-4 z-10 flex items-center gap-1 rounded-lg border border-gray-100 bg-white p-1 shadow-md">
      <Button
        variant="tertiary"
        onClick={onReset}
        disabled={isAtDefaultZoom}
        className={clx(
          'flex items-center justify-center rounded-md transition-all',
          !isAtDefaultZoom
            ? 'text-gray-600 hover:bg-gray-50 active:bg-gray-100'
            : 'cursor-not-allowed text-gray-300'
        )}
        aria-label="Reset zoom"
      >
        <Icon path={mdiRefresh} customSize={0.9} />
      </Button>

      <div className="w-px self-stretch bg-gray-200" />

      <Button
        variant="tertiary"
        onClick={onZoomOut}
        disabled={!canZoomOut}
        className={clx(
          'flex items-center justify-center rounded-md transition-all',
          canZoomOut
            ? 'text-gray-600 hover:bg-gray-50 active:bg-gray-100'
            : 'cursor-not-allowed text-gray-300'
        )}
        aria-label="Zoom out"
      >
        <Icon path={mdiMinus} customSize={0.9} />
      </Button>

      <span className="min-w-14 text-center text-sm font-semibold text-gray-700">
        {zoomPercentage}%
      </span>

      <Button
        variant="tertiary"
        onClick={onZoomIn}
        disabled={!canZoomIn}
        className={clx(
          'flex items-center justify-center rounded-md transition-all',
          canZoomIn
            ? 'text-gray-600 hover:bg-gray-50 active:bg-gray-100'
            : 'cursor-not-allowed text-gray-300'
        )}
        aria-label="Zoom in"
      >
        <Icon path={mdiPlus} />
      </Button>
    </div>
  )
}
